import React from "react";
import "../styles/ToniKroosAwards.css";

/**
 * Raw data. Order only matters as a tiebreaker within the same year
 * (the sort below is stable).
 */
const RAW_AWARDS = [
  {
    year: 2006,
    title: "UEFA European Under-17 Championship Golden Player",
    description: "Best player of the tournament",
  },
  {
    year: 2007,
    title: "FIFA U-17 World Cup Golden Ball",
    description: "The best player at the U-17 World Cup in South Korea",
  },
  {
    year: 2007,
    title: "FIFA U-17 World Cup Bronze Shoe",
    description: "Third top scorer in the tournament",
  },
  {
    year: 2007,
    title: "Fritz Walter Medal (Gold)",
    description: "Best German U-18 player",
  },
  {
    year: 2010,
    title: "IFFHS Team of The Decade",
    description: "Selected for the best team of the decade",
  },
  {
    year: 2010,
    title: "IFFHS UEFA Team of The Decade",
    description:
      "Selected for the best team of the decade in UEFA competitions",
  },
  {
    year: 2014,
    title: "FIFA World Cup All-Star Team",
    description: "Best XI from the 2014 World Cup",
  },
  {
    year: 2014,
    title: "FIFA FIFPro World XI",
    description: "Selected for FIFA's best XI",
  },
  {
    year: 2014,
    title: "UEFA Team of the Year",
    description: "Selected for UEFA's best XI",
  },
  {
    year: 2014,
    title: "IFFHS World's Best Playmaker",
    description: "Selected as the best playmaker of the year",
  },
  {
    year: 2016,
    title: "FIFA FIFPro World XI",
    description: "Selected for FIFA's best XI",
  },
  {
    year: 2016,
    title: "UEFA Team of the Year",
    description: "Selected for UEFA's best XI",
  },
  {
    year: 2017,
    title: "FIFA FIFPro World XI",
    description: "Selected for FIFA's best XI",
  },
  {
    year: 2017,
    title: "UEFA Team of the Year",
    description: "Selected for UEFA's best XI",
  },
  {
    year: 2018,
    title: "German Footballer of the Year",
    description: "Selected as the best German player of the year",
  },
  {
    year: 2019,
    title: "GQ German Athlete of the Year",
    description: "Named best athlete by GQ (Gentlemen's Quarterly) magazine",
  },
  {
    year: 2024,
    title: "FIFA FIFPro World XI",
    description: "Selected for FIFA's best XI",
  },
  {
    year: 2024,
    title: "German Footballer of the Year",
    description: "Selected as the best German player of the year",
  },
];

// Chronological: earliest -> latest.
const AWARDS = [...RAW_AWARDS].sort((a, b) => a.year - b.year);

const AWARDS_BY_YEAR = AWARDS.reduce((groups, award) => {
  const group = groups[groups.length - 1];
  if (!group || group.year !== award.year) {
    groups.push({ year: award.year, items: [award] });
  } else {
    group.items.push(award);
  }
  return groups;
}, []);

/* Icons ------------------------------------------------------------------- */

const svgProps = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
  focusable: "false",
};

const TrophyIcon = () => (
  <svg {...svgProps}>
    <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
    <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
    <path d="M4 22h16" />
    <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
    <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
    <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
  </svg>
);

const StarIcon = () => (
  <svg {...svgProps}>
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

const MedalIcon = () => (
  <svg {...svgProps}>
    <circle cx="12" cy="8" r="6" />
    <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11" />
  </svg>
);

const getIconForAward = (title) => {
  if (/Golden|Shoe|Ball/i.test(title)) return <TrophyIcon />;
  if (/XI|Team of|All-Star/i.test(title)) return <StarIcon />;
  return <MedalIcon />;
};

/* Component --------------------------------------------------------------- */

function ToniKroosAwards() {
  return (
    <section className="awards" aria-labelledby="awards-title">
      <div className="awards__inner">
        <header className="awards__header">
          <h2 id="awards-title" className="awards__title">
            Awards &amp; recognition
          </h2>
        </header>

        <ol className="awards__timeline" aria-label="Awards by year">
          {AWARDS_BY_YEAR.map(({ year, items }) => (
            <li key={year} className="awards__group">
              <h3 className="awards__year">{year}</h3>
              <ul className="awards__list">
                {items.map((award) => (
                  <li
                    key={`${award.year}-${award.title}`}
                    className="awards__item"
                  >
                    <span className="awards__icon">
                      {getIconForAward(award.title)}
                    </span>
                    <div>
                      <h4 className="awards__name">{award.title}</h4>
                      <p className="awards__desc">{award.description}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}

export default ToniKroosAwards;
